import { getUrlParamsFetch } from "@/shared";
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from "@/shared/constants";
import { IResponseData, ISupervisorVentaParams } from "@/shared/interfaces/erp/administration/supervisor.interface";
import { useQuery } from "@tanstack/react-query";

const { get } = erpApi();

///* tanSctack query
export const useFetchSupervisorVenta = (params: ISupervisorVentaParams) => {
  return useQuery({
    queryKey: ['supervisores-venta', ...Object.values(params)],
    queryFn: async () => {
      return getSupervisorVenta(params);
    },
  });
};

export const getSupervisorVenta = async (params?: ISupervisorVentaParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  return get<IResponseData>(
    `${urlBackend}api/v1/supervisores-venta/?${queryParams}`,
    true
  );
};